import { Claim } from '../claim/types';
import { ClaimDetailsState } from './types';
import { ReduxAction, setAsyncData } from '../core';
import { ClaimsAction } from '../claim/actions';

const initialState: ClaimDetailsState = {
  claim: { isFetching: false },
};

export function claimDetailsReducer(state: ClaimDetailsState = initialState, action: ReduxAction<any>): ClaimDetailsState {
  switch (action.type) {
    case ClaimsAction.ONE_UPDATED:
      const c: Claim = action.data as Claim;
      return {
        ...state,
        claim: setAsyncData(state.claim, (v) => (v.data = c)),
      };
    default:
      return state;
  }
}
